import type {
  FilterFormValues, TCandidateOrigin, TMatchingResponse, TReference, TReferencePreview,
  TReferenceType,
} from '@vlabs/monokit/entities/matcher/types/types';
import type { Option } from '@vlabs/monokit/shared/ui/options-filter/types';

import type { SearchMatchPayload } from './buildMatchPayload';

export interface SearchCapabilities {
  // ponytail: пустой массив = «фильтр доступен всем» (legacy-поведение, см. isFilterAvailable в FaceFilterForm)
  referenceTypes: TReferenceType[];
  faceCandidateFilters: string[];
  eventCandidateFilters: string[];
  requiredCandidateFilters: Partial<Record<TCandidateOrigin, (keyof FilterFormValues)[]>>;
}

export const isCandidateFilterRequired = (
  capabilities: SearchCapabilities,
  origin: TCandidateOrigin,
  filter: keyof FilterFormValues,
): boolean => capabilities.requiredCandidateFilters[origin]?.includes(filter) ?? false;

export interface SearchApi {
  matchFaces: (payload: SearchMatchPayload) => Promise<TMatchingResponse[]>;
  matchBodies: (payload: SearchMatchPayload) => Promise<TMatchingResponse[]>;
  getReferenceInfo: (reference: TReference) => Promise<TReferencePreview[] | undefined>;
  estimateFace: (file: File) => Promise<unknown>;
  estimateBody: (file: File) => Promise<unknown>;
  getHandlerOptions: () => Promise<Option[]>;
  getListOptions: () => Promise<Option[]>;
  capabilities: SearchCapabilities;
}
